<template>
  <div>
    <Modal v-model="visible" :width="width" :footer-hide="footerHide" :class-name="className" @on-cancel="cancel" class="u-modal">
      <p slot="header" :class="titleClasses">
        <span>{{title}}</span>
      </p>
      <slot></slot>
      <slot name="footer">
        <div slot="footer" class="u-modal-wrapper" v-if="!footerHide">
          <Button type="primary" size="large" @click="handleClose" class="u-modal-btn">{{okText}}</Button>
          <Button size="large" @click="cancel" class="u-modal-btn">取消</Button>
        </div>
      </slot>

    </Modal>
  </div>
</template>

<script>
export default {
  name: "selectModal",
  props: {
    title: {
      type: String,
      default: "提示"
    },
    titleAlign: {
      type: String,
      default: "center",
      validator(value) {
        // 这个值必须匹配下列字符串中的一个
        return ["center", "left"].indexOf(value) !== -1;
      }
    },
    value: {
      type: Boolean,
      default: false
    },
    width: {
      type: [String, Number],
      default: 360
    },
    footerHide: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ""
    },
    okText: {
      type: String,
      default: "确定"
    },
    beforeClose: Function
  },
  data() {
    return {
      visible: this.value
    };
  },
  methods: {
    handleClose() {
      if (typeof this.beforeClose === "function") {
        this.beforeClose(this.define);
      } else {
        this.define();
      }
    },
    define() {
      this.visible = false;
      this.$emit("input", false);
      this.$emit("on-ok");
    },
    cancel() {
      this.close();
    },
    close() {
      this.visible = false;
      this.$emit("input", false);
      this.$emit("on-cancel");
    }
  },
  computed: {
    titleClasses() {
      return {
        "title-center": this.titleAlign === "center"
      };
    }
  },
  watch: {
    value() {
      this.visible = this.value;
    }
  }
};
</script>

<style scoped lang="less">
  .title-center {
    color:#333;
    text-align: center;
    font-size: 16px;
    margin-top: 10px;
  }
</style>
